export default __webpack_public_path__ + "static/nhs-color-1f6d2c0c1de8fc89dce6d8bc9605a198.svg";